module.exports = __webpack_public_path__ + "static/media/khaled-ben-jedida.0d4015d2.jpg";